import { render, staticRenderFns } from "./StrategyDetails.vue?vue&type=template&id=725305ca&scoped=true&"
import script from "./StrategyDetails.vue?vue&type=script&lang=js&"
export * from "./StrategyDetails.vue?vue&type=script&lang=js&"
import style0 from "./StrategyDetails.vue?vue&type=style&index=0&id=725305ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725305ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
